var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{staticClass:"copy-url"},[_c('copy-to-clipboard',{attrs:{"text":_vm.url},on:{"copy":_vm.handleCopy}},[_c('div',[_c('copy-icon',{attrs:{"size":"1.5x"}})],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.url))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }